import classNames from "classnames";

import {SearchComboboxSearchXIcon} from "../icons/SearchComboboxSearchXIcon";
import type {ISearchComboboxEmptyStateProps} from "../types/ISearchComboboxEmptyStateProps";
import {SearchComboboxInlineOption} from "./SearchComboboxInlineOption";

import * as styles from "./SearchComboboxEmptyState.module.css";

/** No-results block; `compact` is the mobile variant with wrapped chips. */
export const SearchComboboxEmptyState = (props: ISearchComboboxEmptyStateProps) => {
    const {icon, title, hint, chipsLabel, chips = [], compact, className, dataTestId} = props;

    return (
        <div role="presentation" className={classNames(styles.emptyState, compact && styles.emptyStateCompact, className)} data-testid={dataTestId}>
            <span className={styles.icon}>{icon ?? <SearchComboboxSearchXIcon size={26} />}</span>
            <div className={styles.title}>{title}</div>
            {hint ? <div className={styles.hint}>{hint}</div> : null}

            {chips.length > 0 ? (
                <div className={styles.chips}>
                    {chipsLabel ? <span className={styles.chipsLabel}>{chipsLabel}</span> : null}
                    {chips.map(({key, ...chip}) => (
                        <SearchComboboxInlineOption key={key} {...chip} baseClassName={styles.chip} activeClassName={styles.chipActive} />
                    ))}
                </div>
            ) : null}
        </div>
    );
};
import classNames from "classnames";

import {SearchComboboxSearchXIcon} from "../icons/SearchComboboxSearchXIcon";
import type {ISearchComboboxEmptyStateProps} from "../types/ISearchComboboxEmptyStateProps";
import {SearchComboboxInlineOption} from "./SearchComboboxInlineOption";

import * as styles from "./SearchComboboxEmptyState.module.css";

/** No-results block; `compact` is the mobile variant with wrapped chips. */
export const SearchComboboxEmptyState = (props: ISearchComboboxEmptyStateProps) => {
    const {icon, title, hint, chipsLabel, chips = [], compact, className, dataTestId} = props;

    return (
        <div role="presentation" className={classNames(styles.emptyState, compact && styles.emptyStateCompact, className)} data-testid={dataTestId}>
            <span className={styles.icon}>{icon ?? <SearchComboboxSearchXIcon size={26} />}</span>
            <div className={styles.title}>{title}</div>
            {hint ? <div className={styles.hint}>{hint}</div> : null}

            {chips.length > 0 ? (
                <div className={styles.chips}>
                    {chipsLabel ? <span className={styles.chipsLabel}>{chipsLabel}</span> : null}
                    {chips.map(({key, ...chip}) => (
                        <SearchComboboxInlineOption key={key} {...chip} baseClassName={styles.chip} activeClassName={styles.chipActive} />
                    ))}
                </div>
            ) : null}
        </div>
    );
};
